import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Separator, ActivitiesContainer, Warning } from './style';
import { CTA, Icon, Text } from '../../../ui/atoms';
import routes from '../../../routes';
import SessionBox from '../../../ui/atoms/SessionBox';
import theme from '../../../ui/theme';
import ButtonsBanner from '../../../ui/components/Tutor/ButtonsBanner';
import ModalPreviewQuiz from '../../../ui/atoms/Modals/ModalPreviewQuiz';
import { withMediaQueries } from '../../hoc/withMediaQueries';

const Sessions = ({ mediaIsPhone, sections }) => {
  return (
    <ActivitiesContainer>
      <div className={mediaIsPhone ? '' : 'd-flex sb title-wrapper'}>
        <Text type="b3" mb={mediaIsPhone ? 16 : 0}>
          Sezione dedicata all’aggiunta delle attività per il discente. Per
          procedere con la creazione del percorso formativo è necessario
          inserire massimo 2 attività.
        </Text>
        <CTA
          btnText="catalogo attività"
          type="tertiary"
          icon="link-external-02"
          onClick={() =>
            window.open(
              `${window.location.origin}${routes.scormList.path}`,
              '_blank'
            )
          }
        />
      </div>
      <Separator />
      {Object.keys(sections).map((k, i) => (
        <SessionBox
          key={`section-${i + 1}`}
          index={i + 1}
          sectionKey={k}
          viewMode
        />
      ))}
      {mediaIsPhone && (
        <>
          <Text type="b3" className="mt-5" mb={24} color={theme().colors.fail}>
            * campo obbligatorio
          </Text>
          <Warning>
            <Icon type="alert-circle" size={16} />
            <Text type="b4" className="warning d-flex align-start">
              Per procedere con la creazione del percorso formativo è necessario
              inserire almeno 2 attività in totale all’interno di una o più
              sezioni
            </Text>
          </Warning>
        </>
      )}
      <ButtonsBanner
        hasMandatoryFields
        nextEnabled
        warning="Per procedere con la creazione del percorso formativo è necessario inserire almeno 2 attività in totale all’interno di una o più sezioni"
      />
      <ModalPreviewQuiz isEvent />
    </ActivitiesContainer>
  );
};

Sessions.propTypes = {
  mediaIsPhone: PropTypes.bool,
  sections: PropTypes.object,
};

export default connect(
  (state) => {
    const { sections } = state.tutors.activities;
    const { activeTab } = state.tutors;
    return { sections, activeTab };
  },
  (dispatch) => ({})
)(withMediaQueries(Sessions));
